import { el } from "@dhx/ts-common/dom";
import { isDefined } from "@dhx/ts-common/core";
import { getFormItemCss } from "../helper";
import { Input } from "./input";

export class Text extends Input {
	protected _draw() {
		const {
			id,
			value,
		} = this.config;
		return el("div.dhx_form-group.dhx_form-group--textinput", {
			class: getFormItemCss(this.config)
		}, [
			this._drawLabel(),
			el(".dhx_input__wrapper", [
				el("input.dhx_input.dhx_input--textinput", {
					type: "text",
					readOnly: true,
					id,
					value: isDefined(value) ? value : "",
					name: name || ""
				}),
			])
		]);
	}
}